import {CuiBaseComponent} from '@cicero/webui/lib/core/shared/base-component';
import {Component, EventEmitter, Inject} from '@angular/core';
import {Reservation} from '../../models/reservation';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {ReservationService} from '../shared/reservation.service';

@Component({
  selector: 'app-reservation-dialog',
  templateUrl: './reservation-dialog.component.html',
  styleUrls: ['./reservation-dialog.component.scss']
})
export class ReservationDialogComponent extends CuiBaseComponent {
  reservationStateChange = new EventEmitter();

  private outstandingTasks = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public reservation: Reservation,
    public dialogRef: MatDialogRef<void>,
    public reservationService: ReservationService,
    public dialog: MatDialog
  ) {
    super();
  }

  close() {
    this.dialogRef.close();

    if (!this.outstandingTasks) {
      this.complete();
    }
  }

  markNotFound() {
    this.outstandingTasks = true;

    this.reservationService.markNotFound(this.reservation)
      .subscribe(
        null,
        () => this.reservationStateChange.emit(),
        () => this.complete()
      );

    this.reservationStateChange.emit();
    this.close();
  }

  markSkipped() {
    this.reservationService.markSkipped(this.reservation);
    this.reservationStateChange.emit();
    this.close();
  }

  markFound() {
    this.reservationService.markFound(this.reservation).subscribe();
    this.reservationStateChange.emit();
    this.close();
  }

  undo() {
    this.reservationService.undo(this.reservation).subscribe();
    this.reservationStateChange.emit();
  }

  private complete() {
    this.outstandingTasks = false;
    this.reservationStateChange.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/pick-up-list/reservation-dialog/reservation-dialog.component.ts